const CHANNEL_LABELS: Record<string, string> = {
  ADMIN: "Admin",
  WHATSAPP_SELF: "WhatsApp self-scan",
};

const MATCH_SOURCE_LABELS: Record<string, string> = {
  ITS: "ITS",
  SABIL: "Sabil",
  VISITOR: "Visitor",
};

export function formatAttendanceChannel(value: unknown, empty = "—"): string {
  if (value == null || value === "") return empty;
  const key = String(value);
  return CHANNEL_LABELS[key] ?? key;
}

export function formatAttendanceMatchSource(value: unknown, empty = "—"): string {
  if (value == null || value === "") return empty;
  const key = String(value);
  return MATCH_SOURCE_LABELS[key] ?? key;
}

export function formatYesNo(value: unknown, empty = "—"): string {
  if (value == null) return empty;
  return value ? "Yes" : "No";
}

export function formatOptionalText(value: unknown, empty = "—"): string {
  const text = String(value ?? "").trim();
  return text || empty;
}

/** Prefer phone; fall back to attendee key (proxy family check-ins). */
export function formatCheckedInBy(
  row: { checkedInByPhone?: unknown; checkedInByAttendeeKey?: unknown },
  empty = "—"
): string {
  const phone = String(row.checkedInByPhone ?? "").trim();
  if (phone) return phone;
  const key = String(row.checkedInByAttendeeKey ?? "").trim();
  return key || empty;
}

/** List/create primary attendee label: ITS, then name, then key. */
export function formatAttendanceAttendeeLabel(
  row: { attendeeIts?: unknown; attendeeName?: unknown; attendeeKey?: unknown },
  empty = "—"
): string {
  const its = String(row.attendeeIts ?? "").trim();
  if (its) return its;
  const name = String(row.attendeeName ?? "").trim();
  if (name) return name;
  const key = String(row.attendeeKey ?? "").trim();
  return key || empty;
}

/** Check whether an attendance record belongs to a Sabil holder or Mehmaan. */
export function isSabilHolderRecord(row: {
  jamaatMohalla?: unknown;
  notes?: unknown;
  matchSource?: unknown;
  attendeeKey?: unknown;
}): boolean {
  const mohalla = `${String(row?.jamaatMohalla ?? "")} ${String(row?.notes ?? "")}`.toLowerCase();
  if (
    mohalla.includes("mehman") ||
    mohalla.includes("mehmaan") ||
    mohalla.includes("muttavatin") ||
    mohalla.includes("muttavatteen") ||
    mohalla.includes("visitor")
  ) {
    return false;
  }
  if (
    mohalla.includes("sabil") ||
    row?.matchSource === "SABIL" ||
    String(row?.attendeeKey ?? "").startsWith("sm:") ||
    String(row?.attendeeKey ?? "").startsWith("sabil:")
  ) {
    return true;
  }
  return false;
}

export function formatAttendanceAffiliation(row: {
  jamaatMohalla?: unknown;
  notes?: unknown;
  matchSource?: unknown;
  attendeeKey?: unknown;
}): { label: string; isSabil: boolean } {
  const isSabil = isSabilHolderRecord(row);
  return {
    label: isSabil ? "Sabil Holder" : "Mehmaan / Visitor",
    isSabil,
  };
}
